<template>
  <el-dialog
    title="交易详情"
    width="800px"
    v-model="dialogVisible"
    @close="handleClose"
  >
    <el-tabs v-model="activeTab">
      <el-tab-pane label="消费记录" name="consume">
        <div v-if="loading" class="loading-container">
          <el-skeleton animated />
        </div>
        <el-empty v-else-if="consumeRecords.length === 0" description="暂无消费记录" />
        <el-table v-else :data="consumeRecords" style="width: 100%">
          <el-table-column prop="consumptionTime" label="时间" width="180"></el-table-column>
          <el-table-column prop="amount" label="消费金额" width="120">
            <template #default="scope">
              <span class="expense-amount">-{{ scope.row.amount }}</span>
            </template>
          </el-table-column>
          <el-table-column prop="description" label="说明"></el-table-column>
        </el-table>
      </el-tab-pane>

      <el-tab-pane label="充值记录" name="recharge">
        <div v-if="loading" class="loading-container">
          <el-skeleton animated />
        </div>
        <el-empty v-else-if="rechargeRecords.length === 0" description="暂无充值记录" />
        <el-table v-else :data="rechargeRecords" style="width: 100%">
          <el-table-column prop="consumptionTime" label="时间" width="180"></el-table-column>
          <el-table-column prop="amount" label="充值金额" width="120">
            <template #default="scope">
              <span class="recharge-amount">+{{ scope.row.amount }}</span>
            </template>
          </el-table-column>
          <el-table-column prop="paymentMethod" label="支付方式" width="450">
            <template #default="scope">
              {{ getPaymentMethodName(scope.row.paymentMethod) }}
            </template>
          </el-table-column>
        </el-table>
      </el-tab-pane>
    </el-tabs>

    <footer class="tac" style="margin-top: 30px">
      <el-button @click="handleClose">关闭</el-button>
    </footer>
  </el-dialog>
</template>

<script>
import { defineComponent, ref, watch } from "vue";
import { ElMessage } from "element-plus";
import { apiGetUserTransactions } from "@/api/requestApis.js";

export default defineComponent({
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    userId: {
      type: String,
      required: true
    }
  },
  emits: ['update:visible'],
  setup(props, { emit }) {
    const dialogVisible = ref(false);
    const activeTab = ref('consume');
    const consumeRecords = ref([]);
    const rechargeRecords = ref([]);
    const loading = ref(false);

    // 支付方式映射
    const paymentMethodMap = {
      1: '充值',
      2: '消费'
    };

    const getPaymentMethodName = (method) => {
      return paymentMethodMap[method] || '未知';
    };

    watch(() => props.visible, (newVal) => {
      dialogVisible.value = newVal;
        console.log(123)
      if (newVal) {
        loadTransactionData();
      }
    });

    const handleClose = () => {
      dialogVisible.value = false;
      emit('update:visible', false);
    };

    const loadTransactionData = async () => {
      if (!props.userId) return;

      try {
        loading.value = true;
        const res = await apiGetUserTransactions({ id: props.userId });
          console.log(res)
        // 根据后端返回的数据结构进行处理
        if (res) {
            console.log(222)
          // 分离消费记录和充值记录
          const allRecords = res.consumeList;

          consumeRecords.value = allRecords.filter(record => record.paymentMethod === 2);
          rechargeRecords.value = allRecords.filter(record => record.paymentMethod === 1);
        }
      } catch (error) {
        ElMessage.error("获取交易记录失败");
      } finally {
        loading.value = false;
      }
    };

    return {
      dialogVisible,
      activeTab,
      consumeRecords,
      rechargeRecords,
      loading,
      handleClose,
      loadTransactionData,
      getPaymentMethodName
    };
  }
});
</script>

<style scoped>
.loading-container {
  padding: 20px 0;
}

.expense-amount {
  color: #f56c6c;
  font-weight: bold;
}

.recharge-amount {
  color: #67c23a;
  font-weight: bold;
}

.gift-amount {
  color: #409eff;
  font-weight: bold;
}

.tac {
  text-align: center;
}
</style>
